module.exports = __webpack_public_path__ + "img/slide-2__md.c65fd208.jpg";